import RestBase from '@/services/base/RestBase'

export default class PixService extends RestBase {
    constructor() {
        super('', '', 1);
    }
    
    async criarCobranca(txId, data) {
        return this.put(`/v3/recebimentos/cob/${txId}`, data);
    }
    
    async consultarCobranca(txId) {
        return this.get(`/v3/recebimentos/cob/${txId}`);
    }

    async consultarQRCode(txId) {
        return this.get(`/v3/recebimentos/qrcode/cob/${txId}`);
    }

    async cancelaCobranca(txid, status) {
        return this.patch(`/v3/recebimentos/cob/${txid}`, status);
    }
}